import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postCancelReschedule = async (id) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `productivity-host/cancel-reschedule/${id}`,
  });

  return data?.data;
};

export default postCancelReschedule;
